import React from "react";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import TaskFormProgress from "./task-form-progress";
import PropTypes from "prop-types";
import { scrollToTopByClassName } from "../../../../util/general-helpers";

export default function TaskFormFooter({
  totalForms,
  currentSubForm,
  SaveSubForm,
  values,
  isSubmitting,
  setSubmitting,
  IsView
}) {
  return (
    <div className="d-flex justify-content-end footer">
      <TaskFormProgress max={totalForms} currentSubForm={currentSubForm} />
      {currentSubForm?.DisplayOrder > 1 && (
        <FluentButton
          onClick={() => {
            SaveSubForm(setSubmitting, values, "Back");
            scrollToTopByClassName("form-fields-main");
          }}
          text={"Back"}
          backgroundColor={"#0F6CBD"}
          disabled={isSubmitting}
        />
      )}
      <div className="footer-action-button">
        {currentSubForm?.DisplayOrder === totalForms ? (
          !IsView && <FluentButton
            onClick={() => SaveSubForm(setSubmitting, values, "Complete")}
            appearance="primary"
            text={"Complete"}
            backgroundColor={"#0F6CBD"}
            disabled={isSubmitting}
          />
        ) : (
            <div className="next-section-btn">
              <FluentButton
                onClick={() => {
                  SaveSubForm(setSubmitting, values, "Next");
                  scrollToTopByClassName("form-fields-main");
                }}
                text={"Next"}
                backgroundColor={"#0F6CBD"}
                disabled={isSubmitting}
              />
              {!IsView &&<FluentButton
                onClick={() => {
                  SaveSubForm(setSubmitting, values, "Save and Next");
                  scrollToTopByClassName("form-fields-main");
                }}
                appearance="primary"
                text={"Save and Next"}
                backgroundColor={"#0F6CBD"}
                disabled={isSubmitting}
              />}
            </div>         
        )}
      </div>
    </div>
  );
}

TaskFormFooter.propTypes = {
  totalForms: PropTypes.number.isRequired,
  currentSubForm: PropTypes.shape({
    DisplayOrder: PropTypes.number.isRequired,
  }).isRequired,
  SaveSubForm: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setSubmitting: PropTypes.func.isRequired,
};
